module.exports = __webpack_public_path__ + "static/media/accessory27.6f9843a0.webp";